import { ISchema, PaywallComponentProps } from '../../@types'
import { mergeDeep } from '@/helpers/utils'
import { dateProvider } from '@/helpers/date'

export default (schema: ISchema): ISchema => {
	const order = [...(schema.order ?? [])]
	const firstTitle = order.findIndex((entry) => (Array.isArray(entry) ? entry[0] : entry) === 'PaywallTitle')

	order[firstTitle] = [
		'PaywallTitle',
		({ $t, ctx }): PaywallComponentProps.Title => ({
			title: ctx.removeDiscount
				? $t('tai_chi_walking_f_v2.paywall.plan_is_ready')
				: `YOUR TAI CHI WALKING PLAN — <span style="color: var(--Text-Rose)">START FRESH THIS ${dateProvider
						.toWeekday(new Date())
						.toUpperCase()} WITH 75% OFF</span>`,
			textAlignment: 'center',
		}),
	]

	return mergeDeep(
		{ ...schema },
		{
			order,
			components: {
				PaywallCountdown: (): PaywallComponentProps.Countdown => ({
					text: `${dateProvider.toWeekday(new Date())} offer ends in {time} min`,
				}),
			},
		},
	)
}
